import { module }from 'stereomodularjs';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import ResizeObserver from 'resize-observer-polyfill';

gsap.registerPlugin(ScrollTrigger);

export default class extends module {
    constructor(m) {
        super(m);
    }
    init() {
        const sections = gsap.utils.toArray('*[data-anchor]');
        this.ItemInViewport = 1;
        this.windowWidth = window.innerWidth;
        this.sectionsCount = sections.length;
        this.linkWrapper = document.querySelector('.c-nav-anchors-list');
        this.currentActive = 0;
        this.percentRounded = 0.01;
        this.currentActive = 0;
        this.anchorsMQ = {
            '99999': [10], 
            '1920': [8], 
            '1800': [7], 
            '1440': [6], 
            '960': [1],
            '768': [1],
            '480': [1]
        };
        
        this.mobileLinks = document.querySelectorAll('.c-nav-anchors-mobile__link');
        this.mobileLinks.forEach((link) => {
            link.addEventListener('click', (e) => {
                document.querySelector('html').classList.remove('is-anchorsnav-active');
                document.querySelector(link.getAttribute('href')).blur();
                try {
                    if (window.isProgram) {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'click_programme_onglet',
                            'page_category': 'Programmes',
                            'departement': programInfos.departement,
                            'cycle': programInfos.cycle,
                            'diplome': programInfos.diplome,
                            'programme_code': programInfos.code,
                            'programme_nom': programInfos.name,
                            'onglet': link.querySelector('.c-nav-anchors__link-text').innerHTML,
                        });
                    }
                }
                catch(e) {

                }
            });
        })

        this.linkWrapper.querySelectorAll('a').forEach((link) => {
            link.addEventListener('click', (e) => {
                try {
                    if (window.isProgram) {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'click_programme_onglet',
                            'page_category': 'Programmes',
                            'departement': programInfos.departement,
                            'cycle': programInfos.cycle,
                            'diplome': programInfos.diplome,
                            'programme_code': programInfos.code,
                            'programme_nom': programInfos.name,
                            'onglet': link.querySelector('.c-nav-anchors__link-text').innerHTML,
                        });
                    }
                    if (window.isAdmission && link.querySelector('.c-nav-anchors__link-text').innerHTML.match(/date/i)) {
                        window.dataLayer.push({
                            'event': 'click_dates-admission',
                            'page_category': window.pageCategory,
                            'departement': '',
                            'cycle': '',
                            'diplome': '',
                            'programme_code': '',
                            'programme_nom': ''
                        });
                    }
                }
                catch (e) {

                }
            });
        });

        // Set scroll trigger for progress
        if (sections) {
            // value top bottom desktop
            let pageTop = 'top 33%';
            let pageBottom = 'bottom 33%';
            if(window.innerWidth < 960){
                // value top bottom mobile
                pageTop = 'top 50%';
                pageBottom = 'bottom 50%';
            }
            for (let i = 0; i < sections.length; i++) {
                const section = sections[i];
                ScrollTrigger.create({
                    trigger: section,
                    start: pageTop,
                    end: pageBottom,
                    markers: false,
                    onEnter: () => {
                        // desktop
                        classAdd(document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-current');
                        classRemove(document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-prev');
                        // mobile
                        classAdd(document.querySelector('.c-nav-anchors-mobile__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-current');
                    },
                    onLeave: () => {
                        // desktop
                        classRemove(document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-current');
                        classAdd(document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-prev');
                        // mobile
                        classRemove(document.querySelector('.c-nav-anchors-mobile__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-current');
                    },
                    onEnterBack: () => {
                        // desktop
                        classAdd(document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-current');
                        classRemove(document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-prev');
                        // mobile
                        classAdd(document.querySelector('.c-nav-anchors-mobile__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-current');
                    },
                    onLeaveBack: () => {
                        // desktop
                        classRemove(document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-current');
                        classRemove(document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-prev');
                        // mobile
                        classRemove(document.querySelector('.c-nav-anchors-mobile__link[href="#' + section.dataset.anchor + '"]').parentNode, 'is-current');
                    },
                    onUpdate: (self) => {
                        this.currentActive = i;
                        const progress = self.progress.toFixed(4);
                        const percent = progress * 100;
                        this.percentRounded = Math.round(progress * 100);
                        const progressBarEl = document.querySelector('.c-nav-anchors__link[href="#' + section.dataset.anchor + '"]').nextElementSibling;

                        if (progress && progressBarEl) {
                            progressBarEl.style.cssText += `width: ${percent}%;`;
                        }

                        this.update();
                    },
                });
            }

            if(this.ItemInViewport > 1){
                // Set width of link wrapper
                let linkWrapperWidth = this.sectionsCount / this.ItemInViewport * 100;
                this.linkWrapper.style.cssText = "width:" + linkWrapperWidth + "%";
            // console.log('Passed');
            }

            this.update();

            window.addEventListener('resize', () => {
                this.update();
            });

            this.linkWrapper.addEventListener('wheel', (e) => {
                //console.log('init scroll');
                this.scroll(e);
            });

            let resizeTimeout;

            const resizeObserver = new ResizeObserver(entries => {
                clearTimeout(resizeTimeout);
                resizeTimeout = setTimeout(() => {
                    this.update();
                    ScrollTrigger.refresh();
                }, 302);
            });
            resizeObserver.observe(document.querySelector('body'));
        }

        window.addEventListener('resize', () => {
            this.getNavHeight();
        });
        window.addEventListener('orientationchange', () => {
            this.getNavHeight();
        });
        this.getNavHeight();

        classAdd(document.querySelector('html'), 'has-nav-anchors');
    }

    scroll(event){
        console.log(event);
    }

    update(){

        // Set position of link wrapper
        this.windowWidth = window.innerWidth;

        for (let i = 0; i < Object.keys(this.anchorsMQ).length; i++) {
            const key = Object.keys(this.anchorsMQ)[i];
            if (this.windowWidth <= key) {
                this.ItemInViewport = this.anchorsMQ[key];
                break;
            }
        }

        // Set width of link wrapper
        let linkWrapperWidth = this.sectionsCount * 100 / this.ItemInViewport ;
        this.linkWrapper.style.cssText = "width:" + linkWrapperWidth + "%";
        
        if (this.sectionsCount > this.ItemInViewport && this.ItemInViewport > 1) {
            // current offset
            let offset = ((0.01 * this.percentRounded) + this.currentActive - (this.ItemInViewport / 2)) * 100 / this.sectionsCount;
            // max offset
            let offsetCalc = ((this.sectionsCount - this.ItemInViewport) * 100 / this.sectionsCount);
            
            if (offset > offsetCalc) {
                offset = offsetCalc;
            }

            this.linkWrapper.style.cssText += "transform: translateX(-" + offset + "%)";
            
        } else {
            this.linkWrapper.style.cssText = "";
        }
    }

    getNavHeight() {
        // get height of nav anchors
        let navHeight = document.querySelector('.c-nav-anchors').clientHeight;
        // set css variable
        document.documentElement.style.setProperty('--nav-anchor-height', `${navHeight}px`);
    }
}
